<template>
  <div class="map-q">
    <template v-if="mapPattern">
      <map-pattern :issue="issue" />
    </template>
    <template v-else-if="textPattern">
      <text-map :issue="issue" />
    </template>
  </div>
</template>

<script>
import TextMap from '@/questions/components/map/TextMap'
import MapPattern from '@/questions/components/map/MapPattern'

export default {
  name: 'MapQ',
  components: { MapPattern, TextMap },
  changeExpr: 'issue.value',
  computed: {
    pattern() {
      return this.question.issue.displayType
    },
    textPattern() {
      return this.pattern === 0
    },
    mapPattern() {
      return this.pattern === 1
    }
  }
}
</script>

<style scoped></style>
